import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';

const customiser = (objValue, srcValue) => {
  if (isArray(srcValue)) {
    return srcValue;
  }
};

export const mergeConfigs = (actualConfig, channelConfig) => {
  if (!isEmpty(channelConfig)) {
    return mergeWith(actualConfig, channelConfig, customiser);
  }
};
